import React from 'react'
import { Combobox } from 'components/shared/FormFields/common/Combobox/Combobox'
import styles from './DepartmentFilter.module.scss'
import { fetchDepartments } from 'api/departments'
import { t } from 'ttag'
import cx from 'classnames'

import type { OptionMatcher } from 'components/shared/FormFields/common/Combobox/types'

const insert = newStyles => baseStyles => ({
  ...baseStyles,
  ...newStyles,
})

type DepartmentFilterProps = Pick<
  React.ComponentProps<typeof Combobox>,
  'value' | 'onChange' | 'filterOption'
> & {
  className?: string
  matcher?: OptionMatcher
}

export const DepartmentFilter = ({
  value,
  onChange,
  filterOption,
  className,
  matcher = item => {
    const { name, id } = item as { name: string; id: string | number }
    return { label: name, value: id }
  },
}: DepartmentFilterProps) => {
  return (
    <div className={cx(styles.inputContainer, className)}>
      <Combobox
        placeholder={t`Filter by Departments`}
        isSearchable
        filterOption={filterOption}
        styles={{
          valueContainer: insert({ padding: '6px 6px 6px 12px !important' }),
          container: insert({ display: 'flex', alignItems: 'center' }),
          control: insert({
            marginTop: '0.25rem',
            borderColor: '#bbb !important',
          }),
        }}
        isMulti
        fetchOptions={[fetchDepartments, matcher]}
        {...{
          value,
          onChange,
        }}
      />
    </div>
  )
}
